import {DocFile} from "@app/shared";

export class SecurityFramework {
    id: number;
    version: number;
    securityDomainId: number;
    securityControlId: number;
    complianceFramework: string;

    public constructor(securityDomainId: number, securityControlId: number, complianceFramework: string) {
        this.securityDomainId = securityDomainId;
        this.securityControlId = securityControlId;
        this.complianceFramework = complianceFramework;
    }
}

export class SecurityControl {
    id: number;
    version: number;
    securityDomainId: number;
    securityDomainReference?: string;
    reference: string;
    maturityCategory: string;
    solutionCategory: SolutionCategory;
  nistDescription: string;
  nistAssessmentMethod: string;
    nistAssessmentInterview: string;
    nistAssessmentEvidence: string;
    complianceFrameworks: SecurityFramework[] = [];
}



export class SecurityDomain {
    id: number;
    version: number;
    reference: string;
    description: string;
    domainCategory: string;
    policies: any;
    controls: any;
    complianceFrameworks: SecurityFramework[] = [];
}


export class SecurityRequirement {
    id: number;
    version: number;
    sequenceChar: string;
    description: string;
    securityControlId: number;
    securityControlReference?: string;
}

export class SecuritySolutionExpense {
    id: number;
    version: number;
    description: string;
    isPolicySolution: boolean = false;
    isSolutionTaskExpense: boolean = false;
    expenseBudget: number;
    expenseType: string;
    securitySolutionId: number;
    securityRequirementId: number;
    securityControlId: number;

    securityDomainId?: number;
    securityControlIdDisplay?: number;
}

export class SecuritySolutionResource {
    id: number;
    version: number;
    description: string;
    isSubcontractor: boolean = false;
    isPolicySolution: boolean = false;
    isSolutionTaskResource: boolean = false;
    laborHours: number;
    billingRate: number;
    employeeLabor: number;
    subcontractLabor: number;
    durationInDays: number;
    securitySolutionId: number;
    securityRequirementId: number;
    securityControlId: number;
    securityRole: string;

    securityDomainId?: number;
    securityControlIdDisplay?: number;
}

export enum SolutionCategory {
    ACCESS_CONTROL_LIST_SOLUTION = "ACCESS_CONTROL_LIST_SOLUTION",
    ANTIMALWARE_SOLUTION = "ANTIMALWARE_SOLUTION",
    ANTISPAM_SOLUTION = "ANTISPAM_SOLUTION",
    APPLICATION_SECURITY_TESTING = "APPLICATION_SECURITY_TESTING",
    BACKUP_SOLUTION = "BACKUP_SOLUTION",
    APPLICATION_CONTROL = "APPLICATION_CONTROL",
    CENTRALIZED_LOG_MANAGEMENT_SIEM_EVENT_LOG_MONITORING = "CENTRALIZED_LOG_MANAGEMENT_SIEM_EVENT_LOG_MONITORING",
    CERTIFICATE_MANAGEMENT_SOLUTION_PUBLIC_KEY_INFRSTRUCTURE = "CERTIFICATE_MANAGEMENT_SOLUTION_PUBLIC_KEY_INFRSTRUCTURE",
    CHANGE_CONTROL_SOLUTION = "CHANGE_CONTROL_SOLUTION",
    CONFIGURATION_MANAGEMENT_DATABASE = "CONFIGURATION_MANAGEMENT_DATABASE",
    CONTENT_DNS_FILTERING_SOLUTION = "CONTENT_DNS_FILTERING_SOLUTION",
    CRYPTOGRAPHIC_SOLUTION = "CRYPTOGRAPHIC_SOLUTION",
    DATA_CLASSIFICATION_SOLUTION = "DATA_CLASSIFICATION_SOLUTION",
    DATA_DESTRUCTION_SOLUTION = "DATA_DESTRUCTION_SOLUTION",
    DATA_LOSS_PREVENTION = "DATA_LOSS_PREVENTION",
    DISCRETIONARY_ACCESS_CONTROL = "DISCRETIONARY_ACCESS_CONTROL",
    DOCUMENTATION = "DOCUMENTATION",
    EMAIL = "EMAIL",
    EMERGING_THREATS_INTELLIGENCE_FEED = "EMERGING_THREATS_INTELLIGENCE_FEED",
    FILE_INTEGRITY_MONITORING = "FILE_INTEGRITY_MONITORING",
    FORENSIC_SOLUTION = "FORENSIC_SOLUTION",
    GOVERNANCE_RISK_COMPLIANCE = "GOVERNANCE_RISK_COMPLIANCE",
    HUMAN_RESOURCE_MANAGEMENT_SYSTEM = "HUMAN_RESOURCE_MANAGEMENT_SYSTEM",
    IDENTITY_ACCESS_MANAGEMENT = "IDENTITY_ACCESS_MANAGEMENT",
    INCIDENT_RESPONSE_PLAN = "INCIDENT_RESPONSE_PLAN",
    INTRUSION_DETECTION_PREVENTION_SYSTEM = "INTRUSION_DETECTION_PREVENTION_SYSTEM",
    IT_ASSET_MANAGEMENT = "IT_ASSET_MANAGEMENT",
    LEARNING_MANAGEMENT_SYSTEM = "LEARNING_MANAGEMENT_SYSTEM",
    MOBILE_DEVICE_MANAGEMENT = "MOBILE_DEVICE_MANAGEMENT",
    MULTI_FACTOR_AUTHENTICATION = "MULTI_FACTOR_AUTHENTICATION",
    NETWORK_FIREWALL = "NETWORK_FIREWALL",
    NETWORK_BASELINE_MANAGEMENT_SOLUTION = "NETWORK_BASELINE_MANAGEMENT_SOLUTION",
    NETWORK_TIME_PROTOCOL_MANAGEMENT_SOLUTION = "NETWORK_TIME_PROTOCOL_MANAGEMENT_SOLUTION",
    PATCH_MANAGEMENT_SOLUTION = "PATCH_MANAGEMENT_SOLUTION",
    PENETRATION_TESTING_SOLUTION = "PENETRATION_TESTING_SOLUTION",
    PHISHING_AWARENESS_CAMPAIGN_SOLUTION = "PHISHING_AWARENESS_CAMPAIGN_SOLUTION",
    PHYSICAL_ACCESS_CONTROL_SOLUTION = "PHYSICAL_ACCESS_CONTROL_SOLUTION",
    PRIVILEGED_ACCESS_MANAGEMENT = "PRIVILEGED_ACCESS_MANAGEMENT",
    REMOTE_ACCESS_SOLUTION_VPN_CONCENTRATOR = "REMOTE_ACCESS_SOLUTION_VPN_CONCENTRATOR",
    RISK_ASSESSMENT_SOLUTION = "RISK_ASSESSMENT_SOLUTION",
    RISK_REGISTER_POAM_SOLUTION = "RISK_REGISTER_POAM_SOLUTION",
    SANDBOX_DETONATION_CHAMBER_SOLUTION = "SANDBOX_DETONATION_CHAMBER_SOLUTION",
    SECURE_BASELINE_CONFIGURATIONS_SOLUTION = "SECURE_BASELINE_CONFIGURATIONS_SOLUTION",
    SECURE_FILE_SHARING = "SECURE_FILE_SHARING",
    SESSION_RECORDING_SOLUTION = "SESSION_RECORDING_SOLUTION",
    SECURITY_AUTOMATION_AND_RESPONSE = "SECURITY_AUTOMATION_AND_RESPONSE",
    VIRTUAL_DESKTOP_INFRASTRUCTURE = "VIRTUAL_DESKTOP_INFRASTRUCTURE",
    VISITOR_MANAGEMENT = "VISITOR_MANAGEMENT",
    VULNERABILITY_SCANNING_SOLUTION = "VULNERABILITY_SCANNING_SOLUTION",
    WIRELESS_INTRUSION_PREVENTION_SYSTEM = "WIRELESS_INTRUSION_PREVENTION_SYSTEM"
}

export enum SolutionSizeCategory {
    MICRO_SMALL_BUSINESS_LESS_20_USERS = "MICRO_SMALL_BUSINESS_LESS_20_USERS",
    SMALL_BUSINESS_BW_20_200_USERS = "SMALL_BUSINESS_BW_20_200_USERS",
    MEDIUM_BUSINESS_BW_200_500_USERS = "MEDIUM_BUSINESS_BW_200_500_USERS",
    LARGE_BUSINESS_BW_500_2000_USERS = "LARGE_BUSINESS_BW_500_2000_USERS",
    ENTERPRISE_BUSINESS_MORE_2000_USERS = "ENTERPRISE_BUSINESS_MORE_2000_USERS"
}

export enum VendorCategory {
    VERITAS= "VERITAS",
    SYMANTEC= "SYMANTEC",
    CHEF= "CHEF",
    BUGTRAQ= "BUGTRAQ",
    WATCHGUARD= "WATCHGUARD",
    IVANTI= "IVANTI",
    CLICK= "CLICK",
    VERACODE= "VERACODE",
    ONELYNK= "ONELYNK",
    VEEAM= "VEEAM",
    CIS= "CIS",
    KEEPER= "KEEPER",
    AMAZON= "AMAZON",
    HID= "HID",
    FLEXERA= "FLEXERA",
    CERIDIAN= "CERIDIAN",
    ACRONIS= "ACRONIS",
    SURICATA= "SURICATA",
    VORMETRIC= "VORMETRIC",
    SOLARWINDS= "SOLARWINDS",
    PAYCOM= "PAYCOM",
    SAGE= "SAGE",
    DARIKS= "DARIKS",
    RISKLENS= "RISKLENS",
    FBI= "FBI",
    MICROSOFT= "MICROSOFT",
    OKTA= "OKTA",
    SERVICENOW= "SERVICENOW",
    MERAKI= "MERAKI",
    SIMPLERISK= "SIMPLERISK",
    VISIBLEOPS= "VISIBLEOPS",
    PALOALTO= "PALOALTO",
    SAP= "SAP",
    PAESSLER= "PAESSLER",
    DATTO= "DATTO",
    MINDFLASH= "MINDFLASH",
    PUPPET= "PUPPET",
    SABA= "SABA",
    FORTIGATE= "FORTIGATE",
    WEBROOT= "WEBROOT",
    THERECEPTIONIST= "THERECEPTIONIST",
    NABLE= "NABLE",
    NEQTER= "NEQTER",
    VIRTRU= "VIRTRU",
    VARONIS= "VARONIS",
    JIRA= "JIRA",
    OPENDNS= "OPENDNS",
    LOBBYGUARD= "LOBBYGUARD",
    FORTICLIENT= "FORTICLIENT",
    BARRACUDA= "BARRACUDA",
    FILECLOUD= "FILECLOUD",
    LEARNUPON= "LEARNUPON",
    QUALYS= "QUALYS",
    VMWARE= "VMWARE",
    TRIPWIRE= "TRIPWIRE",
    CYBERARK= "CYBERARK",
    CORE= "CORE",
    JUNIPER= "JUNIPER",
    CROWDSTRIKE= "CROWDSTRIKE",
    CYBERPLAN= "CYBERPLAN",
    PREVEIL= "PREVEIL",
    BEYONDTRUST= "BEYONDTRUST",
    ENTRUST= "ENTRUST",
    F5= "F5",
    NGFW= "NGFW",
    USCERT= "USCERT",
    PROOFPOINT= "PROOFPOINT",
    CUICK= "CUICK",
    STRAKEIR= "STRAKEIR",
    CUISUPPLY= "CUISUPPLY",
    TENABLE= "TENABLE",
    EPICOR= "EPICOR",
    RAPID7= "RAPID7",
    CENTRIFY= "CENTRIFY",
    WHITEHAT= "WHITEHAT",
    NNT= "NNT",
    ALIENVAULT= "ALIENVAULT",
    FORCEPOINT= "FORCEPOINT",
    KALI= "KALI",
    FIREEYE= "FIREEYE",
    MCAFEE= "MCAFEE",
    REGDOX= "REGDOX",
    FORENSIC= "FORENSIC",
    OTHER= "OTHER",
    YUBICO= "YUBICO",
    BITDEFENDER= "BITDEFENDER",
    ADOBE= "ADOBE",
    IBM= "IBM",
    NESSUS= "NESSUS",
    THYCOTIC= "THYCOTIC",
    DISA= "DISA",
    ITIL= "ITIL",
    TALENTLMS= "TALENTLMS",
    CONNECTWISE= "CONNECTWISE",
    ORACLE= "ORACLE",
    CITRIX= "CITRIX",
    ENCASE= "ENCASE",
    COMODO= "COMODO",
    DIGITCERT= "DIGITCERT",
    SOPHOS= "SOPHOS",
    REDSEAL= "REDSEAL",
    GITLAB= "GITLAB",
    ILOBBY= "ILOBBY",
    MALWAREBYTES= "MALWAREBYTES",
    DOCKER= "DOCKER",
    KNOWBE4= "KNOWBE4",
    DNSFILTER= "DNSFILTER",
    IDENTRUST= "IDENTRUST",
    GOOGLE= "GOOGLE",
    UNTANGLE= "UNTANGLE",
    CONFIGURE= "CONFIGURE",
    CISCO= "CISCO",
    IGNYTE= "IGNYTE",
    KIWI= "KIWI",
    CIMCOR= "CIMCOR",
    THREATLOCKER= "THREATLOCKER",
    SPLUNK= "SPLUNK",
    WEBTITAN= "WEBTITAN",
    VAULT= "VAULT",
    INFRONT= "INFRONT"
}

export class SecuritySolution {
    id: number;
    version: number;
    name: string;
    description: string;
    solutionProvider: VendorCategory;
    solutionCategory: SolutionCategory;
    solutionSizeCategory: SolutionSizeCategory;
    solutionTask: string;
    solutionExpenses: SecuritySolutionExpense[] = [];
    solutionResources: SecuritySolutionResource[] = [];
}


export class SecurityThreatControl {
    id: number;
    version: number;
    securityThreatId: number;
    securityControlId: number;
    securityControlDescription?: string;
    securityControlReference?: string;
}

export class SecurityThreat {
    id: number;
    version: number;
    name: string;
    reference: string;
    description: string;
    threatType: string;
    threatSource: string;
    isEffective: boolean = true;
    securityAssessmentId?: number;
    referenceSecurityThreatId?: number;
  mitigatingControls: SecurityThreatControl[];
}

export class SecurityPolicyTemplate {
    id: number;
    version: number;
    name: string;
    // reference: string;
    description: string;
    securityDomainId: number;
    policySource?: string;
    domainReference?: string;
    domainCategory?: string;
    policyFileId?: number;
    policyFileName?: string;
    policyFile: DocFile;
}
